import React from "react";

import { TableRow, TableCell, makeStyles } from "../helper";

const useStyles = () => ({
  rowStyle: () => ({ backgroundColor: "rgba(250, 250, 250, 1)" }),
  tableRow: () => ({ "&:last-child td, &:last-child th": { border: 0 } }),
});

const useClasses = makeStyles(() => ({
  label: { fontWeight: 700 },
  subLabel: { fontSize: 12, opacity: 0.64 },
}));

export default function ChallanTableGenericRow({ columnConfig, row }) {
  const styles = useStyles();
  const classes = useClasses();

  const formatter = (formatFunction, value, args) => {
    if (formatFunction) return formatFunction(...args);

    return value;
  };

  return (
    <TableRow sx={styles.tableRow}>
      {columnConfig.map((conf, idx) => {
        return (
          <TableCell key={idx + conf.key} align={conf.align}>
            {formatter(conf.formatFunction, row[conf.key], [
              row[conf.key],
              row.state,
            ])}

            <span className={classes.subLabel}>
              <br />
              {formatter(conf.formatFunctionSubLevel, row[conf.subKey], [
                row[conf.subKey],
              ])}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  );
}
